import axios from "axios";

export const senddevicesIdsService = async (data) => {
  try {
    const API_BASE = "https://api.dev.umb-360.com/api";

    const params = new URLSearchParams();

    
    data.deviceIds.forEach(id => {
      params.append("deviceIds[]", id);
    });

    params.append("start_date", data.start_date);
    params.append("end_date", data.end_date);
    params.append("type", data.type);

    const finalUrl = `${API_BASE}/pdf/data-consumption/view?${params.toString()}`;

    
    window.open(finalUrl, "_blank");

    return finalUrl;

  } catch (err) {
    console.log(err);
  }
};